// src/store.js
import { createStore } from 'redux';

// Example reducer
const rootReducer = (state = {}, action) => {
  switch (action.type) {
    case 'SET_DATA':
      return { ...state, data: action.payload };
    default:
      return state;
  }
};

const store = createStore(rootReducer);

export default store;
